import { Controller } from "@hotwired/stimulus";

export const name = "scroll-hide-header";

export default class extends Controller {
    static targets = ["header"];

    declare readonly headerTarget: HTMLElement;

    lastScrollTop: number = 0;

    connect() {
        this.lastScrollTop = this.getScrollTop();
    }

    onScroll() {
        const currentScrollTop = this.getScrollTop();
        const diff = currentScrollTop - this.lastScrollTop;

        // Ignore small scroll changes or if at top to prevent jitter
        if (Math.abs(diff) < 10) return;

        if (diff > 0 && currentScrollTop > 64) {
            // Scrolling down and not at the very top
            this.hide();
        } else {
            // Scrolling up
            this.show();
        }

        this.lastScrollTop = currentScrollTop;
    }

    getScrollTop() {
        return window.scrollY || document.documentElement.scrollTop;
    }

    hide() {
        this.headerTarget.style.transform = "translateY(-100%)";
    }

    show() {
        this.headerTarget.style.transform = "translateY(0)";
    }
}
